var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtmCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 815,
    height: 329,
    viewBox: "0 0 815 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M755.001 0.5C875.501 39.5 880.501 189 91.0014 180.5C-58.4988 211.5 -66.999 368.5 420.501 318.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtmCurve);
export default __webpack_public_path__ + "static/media/gtm-curve.5c5844faa7befd15a85cd2b6bb2c5357.svg";
export { ForwardRef as ReactComponent };